import * as angular from 'angular';
import dayjs from 'dayjs';
import { IbCLinksService } from 'ib-web-commons/dist/app/core/http-services/angular-statics/services/ib-links-service';
import { DatalayerUtilsService } from 'ib-web-commons/dist/app/core/ib-datalayer/services/ib-datalayer-utils-service';
import { CommonsLanguageAndMarketService } from 'ib-web-commons/dist/app/core/utils/ib-commons-language-and-market-service';
import { CommonsSessionStorageService, TranslateFactoryService } from 'ib-web-commons/utils';
import { MmBDatalayerUtilsService } from './components/services/ib-MmB-datalayer/services/ib-MmB-datalayer-utils-service';
import { MmBUtilService } from './components/services/Utils/ib-MmB-utils';
import { MmBModalService } from './components/ib-reusable-components/ib-MmB-modal/services/ib-MmB-modal-service';
import { KeepAliveUtilService } from './components/ib-reusable-components/ib-keep-alive/services/ib-keep-alive-utils-service';
import { MonetateUtilsService } from './components/ib-reusable-components/ib-monetate/services/ib-monetate-utils';
import { IbMmBGetPhoneCodeService } from './components/services/ib-MmB-get-phone-code-service';

class InitMmBApp {
    constructor (
        private $translate: any,
        private $rootScope: any,
        private MmBAppConstants: MmBAppConstants,
        private CommonsLanguageAndMarketService: CommonsLanguageAndMarketService,
        private IbCLinksService: IbCLinksService,
        private CommonsKeepAliveService: CommonsKeepAliveService,
        private tmhDynamicLocale: any,
        private DatalayerUtilsService: DatalayerUtilsService,
        private MmBDatalayerUtilsService: MmBDatalayerUtilsService,
        private MmBUtilService: MmBUtilService,
        private CommonsAncillariesService: CommonsAncillariesService,
        private MmBModalService: MmBModalService,
        private KeepAliveUtilService: KeepAliveUtilService,
        private localStorageService: any,
        private CommonsUtilService: CommonsUtilService,
        private MonetateUtilsService: MonetateUtilsService,
        private CommonsGetWcsPhonesService: CommonsGetWcsPhonesService,
        private TranslateFactoryService: TranslateFactoryService,
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private IbMmBGetPhoneCodeService: IbMmBGetPhoneCodeService,
        private $ocLazyLoad: any,
    ) {}

    activate = async () => {
        const backToMainEvent = this.$rootScope.$on('backToMainRoot', (event, goToHome, closeSession) => {
            this.MmBUtilService.goToHome();
        });
        //Initilize language and market
        const marketLang = this.CommonsLanguageAndMarketService.init();
        this.tmhDynamicLocale.set(marketLang.language);
        this.$rootScope.appMarket = marketLang.market;
        this.$rootScope.appLang = marketLang.language;
        this.MmBAppConstants.market = marketLang.market;
        this.MmBAppConstants.lang = marketLang.language;
        this.CommonsSessionStorageService.setPrefix('ib-MmB-app');
        //Set translation language to use
        this.$translate.use(marketLang.language);
        this.TranslateFactoryService.setLanguage(this.MmBAppConstants.lang);
        this.IbCLinksService.getLinks(true, 'MMB').then((data) => {
            this.$ocLazyLoad.load(angular.module('ib-commons-filters-module'));
            this.$rootScope.loadLinks = true;
        });
        this.$rootScope.isBackground = false;
        this.$rootScope.extraClassFooter = this.$rootScope.isBackground ? '' : 'ib-footer--medium';
        this.$rootScope.$on('backToMainBackground', (event, isBackground) => {
            this.$rootScope.isBackground = isBackground;
            this.$rootScope.extraClassFooter = this.$rootScope.isBackground ? '' : 'ib-footer--medium';
        });
        this.$rootScope.loadLinks = false;
        this.$rootScope.closeSession = this.CommonsKeepAliveService.closeSession;
        this.$rootScope.MmBPatterns = this.MmBAppConstants.MmBPatterns;
        this.$rootScope.paymentBackgroundImageUrl = this.MmBUtilService.getPaymentsBackGroundURL();
        this.$rootScope.flowName = this.MmBAppConstants.flowName;
        this.$rootScope.showMainHeader = false;
        this.$rootScope.showHeaders = true;
        this.$rootScope.hideAdvancedSearch = true;
        this.$rootScope.serviceAncillarie = this.CommonsAncillariesService;
        this.$rootScope.serviceModal = this.MmBModalService;
        this.$rootScope.routes = {
            icons: this.MmBAppConstants.iconsRoute,
            images: this.MmBAppConstants.imagesRoute,
            templates: this.MmBAppConstants.templatesRoute,
            defaultBackgroundImageUrl: this.MmBUtilService.getBackGroundURL(this.MmBAppConstants.defaultBackgroundImageUrl),
            links: this.MmBAppConstants.linksRoute
        };
        this.$rootScope.phonesList = {};
        this.CommonsGetWcsPhonesService.getPhoneByCode(this.MmBAppConstants.WCS.PHONE_TYPES.SALES).then(() => {
            this.$rootScope.phonesList = this.localStorageService.get('phonesList') || {};
        });
        this.IbMmBGetPhoneCodeService.getPhoneCodesList().then(() => {}, () => {});
        this.$rootScope.backGroundImage = this.$rootScope.paymentBackgroundImageUrl;
        this.$rootScope.serviceURI = this.MmBAppConstants.servicesURI;
        this.$rootScope.otpServicesURI = this.MmBAppConstants.otpServicesURI;
        this.$rootScope.generateDatalayerDOM = this.MmBDatalayerUtilsService.generateDatalayerDOM;
        this.$rootScope.isMobile = this.CommonsUtilService.isMobile();
        /*INIT OLD DATALAYER REMOVE*/
        this.DatalayerUtilsService.initializeDatalayer(marketLang.language, marketLang.market, this.MmBUtilService.getDeviceType());
        /*FINISH OLD DATALAYER REMOVE*/
        this.MmBDatalayerUtilsService.initializeDatalayer(marketLang.language, marketLang.market, this.MmBUtilService.getDeviceType());
        this.MonetateUtilsService.initializeMonetate();
        await import(`dayjs/locale/${this.$rootScope.appLang}`);
        dayjs.locale(this.$rootScope.appLang);
        this.$rootScope.timeSession = {
            startTime: dayjs(),
            openedModal: false,
            failedKeepAliveService: false
        };
        this.$rootScope.showPayButton = true;
        this.KeepAliveUtilService.keepAliveInitMessage();
        this.$rootScope.phonesList = this.localStorageService.get('phonesList') || {};
        this.$rootScope.production = this.MmBAppConstants.production;
    }

    $onInit = this.activate();
};

InitMmBApp.$inject = ['$translate', '$rootScope', 'MmBAppConstants', 'CommonsLanguageAndMarketService', 'IbCLinksService', 'CommonsKeepAliveService', 'tmhDynamicLocale', 'DatalayerUtilsService', 'MmBDatalayerUtilsService', 'MmBUtilService', 'CommonsAncillariesService', 'MmBModalService', 'KeepAliveUtilService', 'localStorageService', 'CommonsUtilService', 'MonetateUtilsService', 'CommonsGetWcsPhonesService', 'TranslateFactoryService','CommonsSessionStorageService', 'IbMmBGetPhoneCodeService','$ocLazyLoad'];
/**
 * Iberia Manage my Booking Angular Application
 * @module ib-manage-my-booking-app
 */
angular.module('ib-MmB-app', [
    'web-manage-my-booking-templates',
        'ngAria',
        'credit-cards',
        'LocalStorageModule',
        'pascalprecht.translate',
        'ng.deviceDetector',
        'ui.bootstrap',
        'duScroll',
        'ui.select',
        'ngAnimate',
        'ngCookies',
        'ngMessages',
        'tmh.dynamicLocale',
        'rx',
        'ib-interceptors-module',
        'rzModule',
        'oc.lazyLoad',
        'ib-MmB-routing-module',
        'ib-MmB-services-module',
        'ib-MmB-transformers-module',
        'ib-MmB-filters-module',
        'ib-MmB-search-module',
        'ib-MmB-booking-management-module',
        'ib-MmB-communication-lost-module',
        'ib-web-menus-module',
        'angular-bind-html-compile',
        'ib-inputs',
        'ib-reusable-components-module',
        'slickCarousel',
        'ib-flexibilization-module',
        'ib-commons-login-module',
        'ib-commons-utils-module',
        'ib-commons-http-service-module',
        'ib-commons-modal-service-module',
        'ib-commons-proxies-module',
        'ib-datalayer-module',
        'ngSanitize',
        'ib-availability-service',
        'ib-fare-service',
        'ib-commons-ui-components-module',
        'ib-commons-directives-module',
        'ib-commons-keep-alive-module',
        'ib-header-main-page-component-module',
        'ib-commons-http-new-service-module',
        'ib-interceptors-module',
        'ib-loading-redirection-module',
        'ib-MmB-voluntary-refunds-module',
        'ib-MmB-payment-module',
        'ib-ng-react-component-module',
        'ib-mmb-payment-page-module',
        'ib-mmb-confirmation-page-module'
]);
angular.module('ib-MmB-app').run(InitMmBApp);
